import {StudentAnnualReportActivity} from 'APIs/letrusAPI/studentAnnualReport/types';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import {Tag} from 'letrus-ui';
import GradeTooltip from './GradeTooltip';
import LegendItem from '../LegendItem';
import styles from './GradesEvolutionChart.module.scss';

interface GradesEvolutionChartProps {
  activities: StudentAnnualReportActivity[];
  grade: string;
  selectedCompetenceInfo: string;
  view: string;
}

export default function GradesEvolutionChart({
  activities,
  grade,
  selectedCompetenceInfo,
  view,
}: GradesEvolutionChartProps) {
  const chartData = activities?.map((activity) => ({
    name: activity?.test_name,
    grade: activity?.grade_details?.points,
    gradeDifference: activity?.grade_details.grade_difference,
    endDate: activity?.end_datetime,
  }));

  function getYAxisMax(grade: string, view: string) {
    if (grade === 'ENEM') {
      if (view === 'competence') {
        return 200;
      }

      return 1000;
    }

    return 10;
  }

  function getGradeDifferenceDot({cx, cy, payload, r = 5}: any) {
    let fillColor = '#f7bb49';

    if (payload?.gradeDifference > 0) {
      fillColor = '#2fac66';
    } else if (payload?.gradeDifference < 0) {
      fillColor = '#962f36';
    }

    return <circle cx={cx} cy={cy} r={r} fill={fillColor} />;
  }
  return (
    <article className={styles.container}>
      <header>
        <h2>Evolução das Notas</h2>

        {view === 'competence' && (
          <Tag
            variant="readOnly"
            backgroundColor="#e8f2fc"
            mainColor="#1d79e6"
            text={selectedCompetenceInfo}
          />
        )}
      </header>

      <ResponsiveContainer width="100%" height={300}>
        <LineChart
          data={chartData}
          margin={{top: 5, right: 30, left: 20, bottom: 40}}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="name"
            angle={-35}
            textAnchor="end"
            interval={0}
            style={{fontSize: 12}}
            tickFormatter={(tick) =>
              tick.length > 18 ? `${tick.slice(0, 18)}...` : tick
            }
          />
          <YAxis domain={[0, getYAxisMax(grade, view)]} />
          <Tooltip content={<GradeTooltip />} />
          <Line
            type="monotone"
            dataKey="grade"
            stroke="#1d79e6"
            dot={(props) => getGradeDifferenceDot({...props, r: 5})}
            activeDot={(props) => getGradeDifferenceDot({...props, r: 8})}
          />
        </LineChart>
      </ResponsiveContainer>

      <section className={styles.legend}>
        <LegendItem color="#2fac66" label="Melhora" />
        <LegendItem color="#962f36" label="Queda" />
        <LegendItem color="#f7bb49" label="Estável" />
      </section>
    </article>
  );
}
